import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import fr from 'facet-rest';
import {
  fetchDataFromLinkQueryParam,
  setNewLinkQueryParam,
  useAgentSchedulerDispatchContext,
} from 'Context/NewAgentSchedulerContext';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import CalendarQuerySelector from '../CalendarQuerySelector';

const styles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    left: '-8vw',
    top: '5vh',
  },
  durationFilter: {
    marginBottom: '20px',
  },
});

const CalendarSidebar = ({
  classes,
  className,
  availabilityPeriodResource,
}) => {
  const { rootNodeProps, logEvent } = useEventTrackingLogEvent({ nodeName: 'Monthly Calendar Sidebar' });
  const dispatch = useAgentSchedulerDispatchContext();

  const bufferDurationMetaOptions = availabilityPeriodResource
    .meta()
    .query(fr.queries.getAvailabilityPeriods.name)
    .field('bufferDuration')
    .options()
    .list();

  const meetingDurationMetaOptions = availabilityPeriodResource
    .meta()
    .query(fr.queries.getAvailabilityPeriods.name)
    .field('duration')
    .options()
    .list();

  const handleSelectMeetingDuration = (option) => {
    const availabilityPeriodUrl = new URL(availabilityPeriodResource.link('self').url());
    const newAvailabilityPeriodQueryParams = new URLSearchParams(availabilityPeriodUrl.search);
    newAvailabilityPeriodQueryParams.set('duration', option.attr('id'));
    availabilityPeriodUrl.search = newAvailabilityPeriodQueryParams.toString();
    logEvent('Set Scheduler Calendar meeting length duration', { duration: option.attr('id') });
    setNewLinkQueryParam(dispatch, availabilityPeriodUrl.toString());
    fetchDataFromLinkQueryParam(dispatch);
  };

  const handleSelectMeetingBuffer = async (option) => {
    const availabilityPeriodUrl = new URL(availabilityPeriodResource.link('self').url());
    const newAvailabilityPeriodQueryParams = new URLSearchParams(availabilityPeriodUrl.search);
    newAvailabilityPeriodQueryParams.set('bufferDuration', option.attr('id'));
    availabilityPeriodUrl.search = newAvailabilityPeriodQueryParams.toString();
    logEvent('Set Scheduler Calendar buffer length duration', { duration: option.attr('id') });
    setNewLinkQueryParam(dispatch, availabilityPeriodUrl.toString());
    fetchDataFromLinkQueryParam(dispatch);
  };


  return (
    <div
      {...rootNodeProps}
      className={classNames(classes.root, className)}
    >
      <CalendarQuerySelector
        className={classNames(classes.durationFilter, className)}
        options={meetingDurationMetaOptions}
        title="Duration"
        selectedQuery={availabilityPeriodResource.attr('selectedDuration')}
        onSelectQuery={handleSelectMeetingDuration}
      />
      <CalendarQuerySelector
        options={bufferDurationMetaOptions}
        title="Buffer"
        selectedQuery={availabilityPeriodResource.attr('selectedBuffer')}
        onSelectQuery={handleSelectMeetingBuffer}
      />
    </div>
  );
};

CalendarSidebar.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  availabilityPeriodResource: PropTypes.object.isRequired,
};

CalendarSidebar.defaultProps = {
  className: '',
};

export default withStyles(styles)(CalendarSidebar);
